import { qs } from './utils.js';
import { updateRatesView } from './prices.js';

function dispatchUploadChange (container) {
    container.dispatchEvent(new CustomEvent('veteran-upload:changed', { bubbles: true }));
}

export function initFakeUploader (container, { errorClass = 'error', hiddenClass = 'd-none' } = {}) {
    return; // Disable fake uploader for now
    const input = qs(container, '#veteranFile');
    const list = qs(container, '#uploadList');
    const uploadBlock = qs(container, '.book__optionUpload');
    if (!input || !list || !uploadBlock) return;

    const label = input.closest('.book__optionUploadLabel');
    const MAX = Number(input.dataset.maxSize || 0);

    const fmtSize = b => {
        const u = ['B', 'KB', 'MB', 'GB']; let i = 0, n = b;
        while (n >= 1024 && i < u.length - 1) { n /= 1024; i++; }
        return `${n.toFixed(n < 10 && i ? 1 : 0)} ${u[i]}`;
    };

    const makeItem = (file) => {
        const li = document.createElement('li');
        li.className = 'book__uploadItem';
        li.innerHTML = `
      <div class="book__fileLeft">
        <div class="book__optionUploadIcon d-flex align-items-center justify-content-center">
            <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.22954 0.979309V3.53631C7.22954 3.88301 7.22954 4.05636 7.29701 4.18878C7.35636 4.30526 7.45106 4.39996 7.56754 4.45931C7.69997 4.52679 7.87332 4.52679 8.22001 4.52679H10.777M10.9438 5.75759V10.222C10.9438 11.2621 10.9438 11.7822 10.7414 12.1794C10.5634 12.5289 10.2793 12.813 9.92981 12.991C9.53254 13.1935 9.01249 13.1935 7.9724 13.1935H4.01049C2.97039 13.1935 2.45034 13.1935 2.05308 12.991C1.70364 12.813 1.41953 12.5289 1.24148 12.1794C1.03906 11.7822 1.03906 11.2621 1.03906 10.222V3.78393C1.03906 2.74383 1.03906 2.22378 1.24148 1.82652C1.41953 1.47707 1.70364 1.19297 2.05308 1.01492C2.45034 0.8125 2.97039 0.8125 4.01049 0.8125H5.99873C6.45297 0.8125 6.68009 0.8125 6.89383 0.863813C7.08332 0.909307 7.26448 0.984344 7.43064 1.08617C7.61806 1.20102 7.77865 1.36162 8.09985 1.68281L10.0735 3.65647C10.3947 3.97767 10.5553 4.13827 10.6702 4.32568C10.772 4.49185 10.847 4.673 10.8925 4.8625C10.9438 5.07623 10.9438 5.30335 10.9438 5.75759Z" stroke="url(#paint0_linear_1584_13575)" stroke-width="1.2381" stroke-linecap="round" stroke-linejoin="round"/>
                <defs>
                    <linearGradient id="paint0_linear_1584_13575" x1="2.687" y1="-1.28921" x2="9.05107" y2="-0.629999" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#1AC67E"/>
                        <stop offset="1" stop-color="#0AC2B7"/>
                    </linearGradient>
                </defs>
            </svg>
        </div>
        <div class="book__fileMeta">
          <p class="book__fileName">${file.name}</p>
          <span class="book__fileSize">(${fmtSize(file.size)})</span>
        </div>
      </div>
      <div class="book__fileRight">
        <div class="book__progress progress">
          <div class="book__progressInner progress-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"></div>
        </div>
        <div class="book__percent">0%</div>
        <button class="book__trashBtn" title="Remove" aria-label="Remove">
          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 4.5V3.9C11 3.05992 11 2.63988 10.8365 2.31901C10.6927 2.03677 10.4632 1.8073 10.181 1.66349C9.86012 1.5 9.44008 1.5 8.6 1.5H7.4C6.55992 1.5 6.13988 1.5 5.81901 1.66349C5.53677 1.8073 5.3073 2.03677 5.16349 2.31901C5 2.63988 5 3.05992 5 3.9V4.5M6.5 8.625V12.375M9.5 8.625V12.375M1.25 4.5H14.75M13.25 4.5V12.9C13.25 14.1601 13.25 14.7902 13.0048 15.2715C12.789 15.6948 12.4448 16.0391 12.0215 16.2548C11.5402 16.5 10.9101 16.5 9.65 16.5H6.35C5.08988 16.5 4.45982 16.5 3.97852 16.2548C3.55516 16.0391 3.21095 15.6948 2.99524 15.2715C2.75 14.7902 2.75 14.1601 2.75 12.9V4.5" stroke="#18181B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
      </div>
    `;
        return li;
    };

    const showError = (msg) => {
        const err = document.createElement('div');
        err.className = 'book__error';
        err.textContent = msg;
        list.appendChild(err);
        setTimeout(() => err.remove(), 3500);
    };

    if (label) {
        ['dragenter', 'dragover'].forEach(evt =>
            label.addEventListener(evt, e => { e.preventDefault(); e.stopPropagation(); label.classList.add('dragover'); })
        );
        ['dragleave', 'drop'].forEach(evt =>
            label.addEventListener(evt, e => { e.preventDefault(); e.stopPropagation(); label.classList.remove('dragover'); })
        );
        label.addEventListener('drop', e => {
            const files = [...(e.dataTransfer?.files || [])];
            if (files.length) handleFiles(files);
        });
    }

    input.addEventListener('change', e => {
        const files = [...e.target.files];
        if (files.length) handleFiles(files);
        input.value = '';
    });

    function fakeUpload (file, { onProgress, onDone, onAbort }) {
        let percent = 25;
        onProgress(percent);
        const tick = () => {
            percent += Math.random() * 12 + 5;
            if (percent >= 100) {
                percent = 100;
                onProgress(percent);
                onDone && onDone({ ok: true, id: crypto.randomUUID() });
                return;
            }
            onProgress(percent);
            timer = setTimeout(tick, 160 + Math.random() * 140);
        };
        let timer = setTimeout(tick, 300);
        return { abort () { clearTimeout(timer); onAbort && onAbort(); } };
    }

    function handleFiles (files) {
        return;
        const file = files[0];
        if (MAX && file.size > MAX) {
            showError(`The file is too large. Maximum ${fmtSize(MAX)}.`);
            return;
        }

        const item = makeItem(file);
        list.appendChild(item);

        list.classList.add('has-active');
        uploadBlock.classList.remove(errorClass);

        const bar = item.querySelector('.book__progressInner');
        const wrap = item.querySelector('.book__progress');
        const pct = item.querySelector('.book__percent');
        const btn = item.querySelector('.book__trashBtn');

        const ctrl = fakeUpload(file, {
            onProgress (p) {
                const v = Math.round(p);
                bar.style.width = v + '%';
                wrap.setAttribute('aria-valuenow', String(v));
                pct.textContent = v + '%';
            },
            onDone (resp) {
                item.dataset.fileId = resp.id;
                updateRatesView(container);
                dispatchUploadChange(container);
            },
            onAbort () { }
        });

        btn.addEventListener('click', () => {
            ctrl.abort();
            item.remove();
            if (!list.querySelector('.book__uploadItem')) {
                list.classList.remove('has-active');
            }
            updateRatesView(container);
            dispatchUploadChange(container);
        });

        updateRatesView(container);
    }
}

export function resetVeteranUpload (container, { errorClass = 'error', hiddenClass = 'd-none' } = {}) {
    return; // Disable fake uploader for now
    const veteranCheck = qs(container, '#veteranCheck');
    const uploadBlock = qs(container, '.book__optionUpload');
    const list = qs(container, '#uploadList');
    const fileInput = qs(container, '#veteranFile');

    if (veteranCheck) veteranCheck.checked = false;
    uploadBlock?.classList.add(hiddenClass);
    uploadBlock?.classList.remove(errorClass);

    if (fileInput) fileInput.value = '';
    if (list) {
        list.innerHTML = '';
        list.classList.remove('has-active');
    }

    updateRatesView(container);
    dispatchUploadChange(container);
}

export function initVeteranUploadToggle (container, { errorClass = 'error', hiddenClass = 'd-none' } = {}) {
    return; // Disable fake uploader for now
    const veteranCheck = qs(container, '#veteranCheck');
    const uploadBlock = qs(container, '.book__optionUpload');

    function syncUploadVisibility () {
        const patientVal = qs(container, '#patient-dropdown')?.dataset.value || '';
        const isNew = patientVal === 'new-patient';
        const on = !!(veteranCheck && veteranCheck.checked && isNew);

        if (uploadBlock) uploadBlock.classList.toggle(hiddenClass, !on);
        if (!on) {
            const list = qs(container, '#uploadList');
            const fileInput = qs(container, '#veteranFile');
            uploadBlock?.classList.remove(errorClass);
            if (fileInput) fileInput.value = '';
            if (list) {
                list.innerHTML = '';
                list.classList.remove('has-active');
            }
        }

        updateRatesView(container);
        dispatchUploadChange(container);
    }

    veteranCheck?.addEventListener('change', syncUploadVisibility);
    syncUploadVisibility();
}